import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { PaginationFilterDto } from "../../../types/Pagination";
import { useQuery } from "@tanstack/react-query";
import { getProfessionals } from "../api/professionalAPI";
import { SelectedFilter } from "../../../components/Filters/types";

type QueryFnType = typeof getProfessionals;

type UseGetProfessionals = {
    config?: QueryConfig<QueryFnType>;
    search?: string;
    filters?: SelectedFilter[];
};

export const useGetProfessionals = ({ config, search = "", filters = [] }: UseGetProfessionals = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.professionals.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.professionals);
    const filterByCurrentUser = useSelector((state: RootState) => state.filters.professionals.filterByCurrentUser);
    const currentUser = useSelector((state: RootState) => state.currentUserInfo.data);
    const filterByOnlyActiveRecords = useSelector((state: RootState) => state.filters.professionals.filterByOnlyActiveRecords);

    const paginationFilters: PaginationFilterDto =
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filterByCurrentUser,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: currentUser.selectedOrganizationalStructureIds,
        filterByOnlyActiveRecords: filterByOnlyActiveRecords
    };

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getProfessionals', selectedFilters, pagination, filterByOnlyActiveRecords],
        queryFn: () => getProfessionals(paginationFilters),
    });
}
